import axios from 'axios';

import { BASE_API_URL, PREFIX_API_PUBLIC } from '@/constants';

export default class CaptchetatService {
  /**
   * Generate a new captcha image.
   * @param type captcha type (default: 'captchaFR')
   * @returns Promise with { uuid, imageb64 }
   */
  public generate(type: string = 'captchaFR'): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(BASE_API_URL + PREFIX_API_PUBLIC + 'captchetat/generate', { type })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  /**
   * Validate a captcha code.
   * @param uuid captcha UUID
   * @param code user-entered code
   * @returns Promise with boolean
   */
  public validate(uuid: string, code: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(BASE_API_URL + PREFIX_API_PUBLIC + 'captchetat/validate', { uuid, code })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
